import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Bot = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 40.105469 20.832031 C 40.105469 19.394531 38.9375 18.230469 37.5 18.230469 L 12.5 18.230469 C 11.0625 18.230469 9.894531 19.394531 9.894531 20.832031 L 9.894531 37.5 C 9.894531 38.9375 11.0625 40.105469 12.5 40.105469 L 37.5 40.105469 C 38.9375 40.105469 40.105469 38.9375 40.105469 37.5 Z M 17.1875 31.25 L 17.1875 27.082031 C 17.1875 26.21875 17.886719 25.519531 18.75 25.519531 C 19.613281 25.519531 20.3125 26.21875 20.3125 27.082031 L 20.3125 31.25 C 20.3125 32.113281 19.613281 32.8125 18.75 32.8125 C 17.886719 32.8125 17.1875 32.113281 17.1875 31.25 Z M 29.6875 31.25 L 29.6875 27.082031 C 29.6875 26.21875 30.386719 25.519531 31.25 25.519531 C 32.113281 25.519531 32.8125 26.21875 32.8125 27.082031 L 32.8125 31.25 C 32.8125 32.113281 32.113281 32.8125 31.25 32.8125 C 30.386719 32.8125 29.6875 32.113281 29.6875 31.25 Z M 43.230469 27.605469 L 45.832031 27.605469 C 46.695312 27.605469 47.394531 28.304688 47.394531 29.167969 C 47.394531 30.03125 46.695312 30.730469 45.832031 30.730469 L 43.230469 30.730469 L 43.230469 37.5 C 43.230469 40.664062 40.664062 43.230469 37.5 43.230469 L 12.5 43.230469 C 9.335938 43.230469 6.769531 40.664062 6.769531 37.5 L 6.769531 30.730469 L 4.167969 30.730469 C 3.304688 30.730469 2.605469 30.03125 2.605469 29.167969 C 2.605469 28.304688 3.304688 27.605469 4.167969 27.605469 L 6.769531 27.605469 L 6.769531 20.832031 C 6.769531 17.667969 9.335938 15.105469 12.5 15.105469 L 23.4375 15.105469 L 23.4375 9.894531 L 16.667969 9.894531 C 15.804688 9.894531 15.105469 9.195312 15.105469 8.332031 C 15.105469 7.46875 15.804688 6.769531 16.667969 6.769531 L 25 6.769531 C 25.863281 6.769531 26.5625 7.46875 26.5625 8.332031 L 26.5625 15.105469 L 37.5 15.105469 C 40.664062 15.105469 43.230469 17.667969 43.230469 20.832031 Z M 43.230469 27.605469 "
        fill={color}
      />
    </svg>
  )
}
